import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import TextField from '@material-ui/core/TextField';

import LOGIN_EMAIL_ACTIONS from "../../constants/LOGIN_EMAIL_ACTIONS";
import ActionRow from './action-row'
import {getTranslation} from "../../helpers/get-translation";


const styles = theme => ({
	root: {
	},
	body: {
		"& > div": {
			width: '100%',
		},
		"& input": {
			display: 'block',
		},
		"@media screen and (max-width: 500px)": {
			"& > div":{
				flexDirection: "column-reverse",
				textAlign: "center",
				"& > span":{
					width: '100%',
					marginTop: '20px',
				}
			}
		}
	},
	error:{
		fontSize: '13px',
		color: 'red'
	},
	cssLabel:{},
	cssFocused:{},
	cssOutlinedInput: {},
	notchedOutline: {},

	defaultInput: {
		"& $cssLabel": {
			'&$cssFocused': {
				color: '#1972e7',
			},
		},
		"& $cssFocused": {},
		"& $cssOutlinedInput": {
			'&$cssFocused $notchedOutline': {
				borderColor: '#1972e7',
			},
		},
	},

	footer:{
		display: 'flex',
		justifyContent: 'space-between',
		margin: '20px 0',
		'& div': {
			padding: '10px',
		},
		'& span, a': {
			color: '#828282',
			cursor: 'pointer',
			'&:hover': {
				color: '#545454'
			}
		},
		"@media screen and (max-width: 500px)":{
			textAlign: "center",
			flexDirection: "column",
			"& > div": {
				width: "100%",
				marginBottom: "15px"
			}
		}
	},

	resetText:{
		textDecoration: "underline"
	}

});

function InputForm(props){

	function renderInput(classes, name, label, type, value, onChange, errorText){
		return(
			<div className={errorText ? '' : classes.defaultInput}>
				<TextField
					fullWidth
					id={`${name}-input`}
					label={label}
					type={type}
					name={name}
					autoComplete={name === 'email' ? 'email' : ''}
					margin="normal"
					variant="outlined"
					value={value}
					onChange={onChange}

					InputLabelProps={{
						classes: {
							root: classes.cssLabel,
							focused: classes.cssFocused,
						},
					}}

					InputProps={{
						classes: {
							root: classes.cssOutlinedInput,
							focused: classes.cssFocused,
							notchedOutline: classes.notchedOutline,
						},
					}}

				/>
				<div className={classes.error}>
					{errorText}
				</div>
			</div>
		)

	}

	function renderEmailInput(classes){
		return renderInput(
			classes,
			"email",
			getTranslation("login_email_email_input"),
			"email",
			props.emailValue,
			props.emailOnChange,
			props.emailError,
		);
	}

	function renderPasswordInput(classes){
		return renderInput(
			classes,
			"password",
			getTranslation("login_email_password_input"),
			"password",

			props.passwordValue,
			props.passwordOnChange,
			props.passwordError
		);
	}

	function renderRepeatInput(classes){
		return renderInput(
			classes,
			"repeat-password",
			getTranslation("login_email_repeat_password_input"),
			"password",
			props.repeatValue,
			props.repeatOnChange,
			props.repeatError
		);
	}

	function renderInputs(classes, action){
		if(loginAction === LOGIN_EMAIL_ACTIONS.LOGIN){
			return (
				<form className={classes.body} onSubmit={
					(e) => {
						e.preventDefault();
						props.setIsConnecting(true);
						props.fsLoginEmail(
							props.emailValue,
							props.passwordValue,
							props.buttonErrorCallback,
							() => props.buttonSuccessCallback(LOGIN_EMAIL_ACTIONS.LOGIN)
						);
					}
				}>
					{renderEmailInput(classes)}

					{renderPasswordInput(classes)}

					<ActionRow
						spanText={getTranslation("login_email_create_account_link")}
						spanOnClick={
							() => {
								props.changeAction(LOGIN_EMAIL_ACTIONS.REGISTER);
								props.resetInputs();
							}
						}

						buttonText={getTranslation("login_email_login_button")}
						isButtonDisabled={
							props.isConnecting
						}
					/>
				</form>
			)
		} else if (loginAction === LOGIN_EMAIL_ACTIONS.REGISTER) {
			return(
				<form className={classes.body} onSubmit={
					(e) =>{
						e.preventDefault();

						props.setIsConnecting(true);
						props.fsCreateAndMergeUserEmail(
							props.emailValue,
							props.passwordValue,
							props.buttonErrorCallback,
							() => props.buttonSuccessCallback(LOGIN_EMAIL_ACTIONS.REGISTER)
						);

					}
				}>
					{renderEmailInput(classes)}

					{renderPasswordInput(classes)}

					{renderRepeatInput(classes)}

					<ActionRow
						spanText={getTranslation("login_email_login_link")}
						spanOnClick={
							() => {
								props.changeAction(LOGIN_EMAIL_ACTIONS.LOGIN);
								props.resetInputs();
							}
						}

						buttonText={getTranslation("login_email_create_account_button")}
						ButtonOnClick={
							() => {
							}
						}

						isButtonDisabled={
							props.isConnecting
						}
					/>
				</form>
			)
		} else {

			return(
				<form className={classes.body} onSubmit={
					(e) =>{
						e.preventDefault();
						props.setIsConnecting(true);

						props.fsResetEmailPassword(
							props.emailValue,
							props.buttonErrorCallback,
							() => props.buttonSuccessCallback(LOGIN_EMAIL_ACTIONS.RESET)
						);

					}
				}>
					{renderEmailInput(classes)}

					<ActionRow
						spanText={getTranslation("login_email_login_link")}
						spanOnClick={
							() => {
								props.changeAction(LOGIN_EMAIL_ACTIONS.LOGIN);
								props.resetInputs();
							}
						}

						buttonText={getTranslation("login_email_remind_password_button")}
						isButtonDisabled={
							props.isConnecting
						}
					/>

				</form>
			)
		}
	}

	function renderFooter(classes, loginAction, contactEmail, privacyPolicyUrl){
		return (
			<div className={classes.footer}>
				<div>{
					loginAction === LOGIN_EMAIL_ACTIONS.LOGIN &&
					<span className={classes.resetText}
					      onClick={() => {
						      props.changeAction(LOGIN_EMAIL_ACTIONS.RESET);
						      props.resetInputs(true)
					      }}
					>
						{getTranslation("login_email_footer_dont_remember_password")}
				</span>
				}</div>
				<div>
					<a href={`mailto:${contactEmail}`}>{getTranslation("login_email_footer_help")}</a>
				</div>
				<div>
					<a href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer">{getTranslation("login_email_footer_privacy")}</a>
				</div>
			</div>
		)
	}

	const { classes, loginAction, contactEmail, privacyPolicyUrl } = props;

	// console.log(props.emailValue);
	// console.log(props.passwordValue);
	// console.log(props.repeatValue);
	return(
		<div className={classes.root}>
			{renderInputs(classes, loginAction)}
			<Divider />
			{renderFooter(classes, loginAction, contactEmail, privacyPolicyUrl)}
		</div>
	)


}

InputForm.propTypes = {
	isConnecting: PropTypes.bool.isRequired,
	contactEmail: PropTypes.string.isRequired,
	privacyPolicyUrl: PropTypes.string.isRequired,

	loginAction: PropTypes.string.isRequired,
	emailValue: PropTypes.string.isRequired,
	passwordValue: PropTypes.string.isRequired,
	repeatValue: PropTypes.string.isRequired,
	emailError: PropTypes.string.isRequired,
	passwordError: PropTypes.string.isRequired,
	repeatError: PropTypes.string.isRequired,

	fsLoginEmail: PropTypes.func.isRequired,
	fsCreateAndMergeUserEmail: PropTypes.func.isRequired,
	fsResetEmailPassword: PropTypes.func.isRequired,

	buttonErrorCallback: PropTypes.func.isRequired,
	buttonSuccessCallback: PropTypes.func.isRequired,
	changeAction: PropTypes.func.isRequired,
	setIsConnecting: PropTypes.func.isRequired,
	emailOnChange: PropTypes.func.isRequired,
	passwordOnChange: PropTypes.func.isRequired,
	repeatOnChange: PropTypes.func.isRequired,
	resetInputs: PropTypes.func.isRequired,
};

export default withStyles(styles)(InputForm);